import { render, staticRenderFns } from "./control-font-weight.vue?vue&type=template&id=799c9b16&"
import script from "./control-font-weight.vue?vue&type=script&lang=js&"
export * from "./control-font-weight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports